// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"e19b5dcd","329":"49128056","453":"d855a71b","863":"8135dde1"}[chunkId] + ".chunk.js";
};